module.exports = __webpack_public_path__ + "static/media/16.94d05c21.jpeg";